import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.FeaturedEvent = class FeaturedEvent extends Snappy.BaseComponent {
    static get tagName() {
        return 'fa-featured-event';
    }

    constructor(element) {
        super(element);
    }

    setVars() {

    }

    render() {
    }

}

$(function () {
   var CWFeaturedEvent = new Snappy.Component.FeaturedEvent();

    $('.expand').click(function () {
        $(this).parent().next().next().fadeIn("fast");
        $(this).parent().closest('.featured-event').addClass('overlay-active');
    });

    $('.exit').click(function () {
        $(this).parent().fadeOut("fast");
        $(this).parent().closest('.featured-event').removeClass('overlay-active');
    });

    $('.featured-event').hover(function () {
        $(this).toggleClass('has-focus');
    });

});



// WEBPACK FOOTER //
// ./components/featured-event/scripts/featured-event.js